import React from 'react';
import type { CommandServices } from '@wix/cli-command-contract';
import { Option, createCommand } from '@commander-js/extra-typings';
import { createI18nT } from '../i18n.js';
import { validateBase, validateSite } from './validations.js';

export const createVersionCommand = (services: CommandServices) => {
  const t = createI18nT();

  return createCommand('create-version')
    .description(t('create_version_command_def.description'))
    .addOption(
      new Option(
        '-t, --version-type <type>',
        t('create_version_command_def.option.version_type')
      ).choices(['major', 'minor'] as const)
    )
    .option(
      '-s, --site <site-id>',
      t('create_version_command_def.option.site'),
      validateSite
    )
    .option(
      '-y, --approve-preview',
      t('create_version_command_def.option.approve_preview')
    )
    .option(
      '--base-url <url>',
      t('create_version_command_def.option.base_url'),
      validateBase
    )
    .action(async (options, command) => {
      const { renderCommand } = await import('./render-command.js');
      const { CreateVersionCommandDeprecated } = await import(
        '../components/CreateVersionCommand/index.js'
      );

      await renderCommand(
        command,
        services,
        <CreateVersionCommandDeprecated />
      );
    });
};
